export default __webpack_public_path__ + "assets/apple-touch-icon-50x50-c23d47b.png";